// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthGuard_container__2KLHt"};